__turbopack_context__.v({
  "contentWrapper": "OuvEeW_contentWrapper",
  "envelopeIcon": "OuvEeW_envelopeIcon",
  "formWrapper": "OuvEeW_formWrapper",
  "privacyMessage": "OuvEeW_privacyMessage",
  "submitButton": "OuvEeW_submitButton",
});
